module.exports = __webpack_public_path__ + "img/qiu360liang.6ace1091.png";